import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { PlatformService } from '../core/platform/platform.service';
import { StorageService } from '../core/platform/storage.service';

export type AppContext = 'admin' | 'coach' | 'parent' | 'player';

@Injectable({
  providedIn: 'root'
})
export class ContextService {
  private readonly storageKey = 'app_context';
  private readonly contextSubject = new BehaviorSubject<AppContext>('admin');
  public readonly context$ = this.contextSubject.asObservable();

  constructor(
    private readonly platformService: PlatformService,
    private readonly storageService: StorageService
  ) {
    if (this.platformService.isBrowser()) {
      const stored = this.storageService.getLocalItem(this.storageKey) as AppContext | null;
      if (stored) {
        this.contextSubject.next(stored);
      }
    }
  }

  getCurrentContext(): AppContext {
    return this.contextSubject.value;
  }

  setContext(context: AppContext): void {
    this.contextSubject.next(context);
    if (this.platformService.isBrowser()) {
      this.storageService.setLocalItem(this.storageKey, context);
    }
  }
}
